import q from "q";
import $ from "jquery";
import {
    IHttpService,
    IHttpRequest,
    IHttpResponse,
    IStorageService,
    LocalStorageService
} from "./CoreExportedFiles";

export class HttpService implements IHttpService {
    cacheStorage: IStorageService;

    public static $inject = ['IStorageService'];

    constructor(cacheStorage: IStorageService = new LocalStorageService()) {
        this.cacheStorage = cacheStorage;
    }

    ajax<T>(request: IHttpRequest): q.Promise<IHttpResponse<T>> {
        return q.fcall(() => {
            if (!request)
                throw new Error("Parameter 'request' cannot be null");

            var type = (request.type || "GET").toUpperCase();

            if (type === "GET")
                return this.doGet<T>(request);
            else if (type === "POST")
                return this.doPost<T>(request);

            throw new Error("Unsupported request type '" + type + "'");
        }).then(value => value);
    }

    get<T>(url: string, cacheKey?: string, contentType?: string): q.Promise<IHttpResponse<T>> {
        return this.ajax<T>({
            url: url,
            type: "GET",
            cacheKey: cacheKey,
            contentType: contentType
        });
    }

    post<T>(url: string, data: any, cacheKey?: string, contentType?: string): q.Promise<IHttpResponse<T>> {
        return this.ajax<T>({
            url: url,
            type: "POST",
            data: data,
            cacheKey: cacheKey,
            contentType: contentType
        });
    }

    protected doGet<T>(request: IHttpRequest): q.Promise<IHttpResponse<T>> {
        if (!request)
            throw new Error("Parameter 'request' cannot be null");

        var url = request.url;
        var data = request.data;
        var key = request.cacheKey;
        var expirationMin = request.expirationMin || 5000;
        var overrideCache = request.overrideCache;

        var defer = q.defer<IHttpResponse<T>>();
        var res : T | undefined;
        var self = this;
        if (key && !overrideCache) {
            const cachedData = this.cacheStorage.get(key);
            res = JSON.parse(cachedData) as T;
        }
        if (res) {
            defer.resolve({ getFromCache: true, data: res});
        }
        else {
            $.ajax({
                url: url,
                type: "GET",
                data: data
            }).done(function (result) {
                if (key) {
                    self.cacheStorage.save(key, result, expirationMin);
                }
                defer.resolve({ getFromCache: false, data: result });
            }).fail(reason => {
                defer.reject(reason);
            });
        }
        return defer.promise;
    }

    protected doPost<T>(request: IHttpRequest): q.Promise<IHttpResponse<T>> {
        if (!request)
            throw new Error("Parameter 'request' cannot be null");

        var url = request.url;
        var data = request.data;
        var key = request.cacheKey;
        var expirationMin = request.expirationMin || 5000;
        var overrideCache = request.overrideCache;
        var contentType = request.contentType || "application/json";

        // convert data to json string by default if they aren't already
        if (data && contentType.toLowerCase() === "application/json" && typeof (data) !== "string") {
            data = JSON.stringify(data);
        }

        var defer = q.defer<IHttpResponse<T>>();
        var self = this;
        var res: T | undefined;
        if (key && !overrideCache) {
            const cachedData = this.cacheStorage.get(key);
            res = JSON.parse(cachedData) as T;
        }
        if (res) {
            defer.resolve({ getFromCache: true, data: res });
        }
        else {
            $.ajax({
                url: url,
                type: "POST",
                data: data,
                contentType: contentType
            }).done(function (result) {
                if (key) {
                    self.cacheStorage.save(key, result, expirationMin);
                }
                defer.resolve({ getFromCache: false, data: result });
            }).fail(reason => {
                defer.reject(reason);
            });
        }
        return defer.promise;
    }
}